import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPQualtdata = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "none",
	height: 24,
	viewBox: "0 0 24 24",
	width: 24,
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "a",
			gradientUnits: "userSpaceOnUse",
			x1: 0,
			x2: 13.839,
			y1: 14.7764,
			y2: 14.7764,
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: 0,
				stopColor: "#0047bb"
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#10069f"
			})]
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "b",
			children: /* @__PURE__ */ _jsx("path", { d: "m0 0h24v23.6429h-24z" })
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#b)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "m21.1434 9.04494v-1.88632c0-.89144-.4752-1.71639-1.2485-2.16211l-8.0747-4.661609c-.7732-.445721-1.7238-.445721-2.49699 0l-8.0747 4.661609c-.773238.44572-1.24851 1.27067-1.24851 2.16211v9.32568c0 .8914.475272 1.7164 1.24851 2.1621l8.07716 4.6641c.77323.4457 1.72383.4457 2.49703 0l1.6327-.9432c.5146-.2979.5146-1.0392 0-1.3347l-4.605-2.6595c-.47773-.2758-.77078-.7856-.77078-1.3372v-5.7648c0-.5516.29305-1.0614.77078-1.33472l4.9916-2.88118c.4777-.27581 1.0663-.27581 1.5415 0l4.605 2.65955c.5122.29555 1.1549-.07634 1.1549-.66981z",
					fill: "#0047bb"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "m23.2269 14.4625-2.4971-1.4406c-.4777-.2758-1.0663-.2758-1.5415 0l-2.4971 1.4406c-.4777.2758-.7707.7856-.7707 1.3347v2.8812c0 .5516.293 1.0613.7707 1.3347l2.4971 1.4406c.4777.2758 1.0663.2758 1.5415 0l2.4971-1.4406c.4777-.2758.7707-.7856.7707-1.3347v-2.8812c.0025-.5491-.293-1.0589-.7707-1.3347z",
					fill: "#0047bb"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "m.334907 5.9101c-.216705.37184-.334907.80279-.334907 1.24851v9.32569c0 .8914.475272 1.7164 1.24851 2.1621l8.07716 4.6641c.77323.4457 1.72383.4457 2.49703 0l1.6327-.9432c.5146-.298.5146-1.0392 0-1.3347l-4.605-2.6595c-.47774-.2759-.77078-.7856-.77078-1.3372v-5.7648c0-.2758.07388-.5418.20686-.7708z",
					fill: "url(#a)"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "m16.1295 15.0291c-.133.2315-.2068.495-.2068.7708v2.8812c0 .5516.293 1.0613.7707 1.3347l2.4971 1.4406c.2388.1379.5048.2068.7707.2068v-3.5337c0-.5516-.293-1.0614-.7707-1.3372z",
					fill: "#10069f"
				})
			]
		})
	]
});
export default SvgPQualtdata;
